import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { StackedGallery } from '@dmm/lib-react-ui-components';
import { prepareMediaItemsForStackedGallery, populateMediaArray } from '../../utils/listingHelper';
import AdProvider from '../../components/Ads/AdProvider';
import './styles.css';

const ModalWrapper = ({ children }) => {
  return (
    <Modal isOpen={true} className="stacked-gallery-modal" overlayClassName="stacked-gallery-modal-overlay" ariaHideApp={false}>
      <div>{children}</div>
    </Modal>
  );
};

ModalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const StackedGalleryModal = (props) => {
  const {
    listing,
    onClickShare,
    hideModal,
    adParams,
    isLoading,
    pageAdsConfig,
    targeting,
    bdpUrl
  } = props;

  let galleryMediaItems = populateMediaArray(listing, true);
  const mediaItems = prepareMediaItemsForStackedGallery(galleryMediaItems, adParams);
  const handleCloseModal = () => {
    hideModal();
  };

  useEffect(() => {
    const handleBodyOverflow = () => {
      document.body.style.overflow = props.show ? 'hidden' : 'auto';
    };
    handleBodyOverflow();

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [props.show]);

  if (!props.show) {
    return null;
  }
  return (
    <AdProvider url={bdpUrl} isWorking={isLoading} targeting={targeting} adsConfig={pageAdsConfig}>
      <ModalWrapper>
        <>
          <StackedGallery onClickBack={handleCloseModal} onClickShare={onClickShare}>
            {mediaItems}
          </StackedGallery>
        </>
      </ModalWrapper>
    </AdProvider>
  );
};

StackedGalleryModal.propTypes = {
  listing: PropTypes.object,
  hideModal: PropTypes.func,
  show: PropTypes.bool,
  onClickShare: PropTypes.func,
  adParams: PropTypes.object,
  isLoading: PropTypes.bool,
  pageAdsConfig: PropTypes.object,
  targeting: PropTypes.object,
  bdpUrl: PropTypes.string,
};

  export default StackedGalleryModal;
